import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import PropTypes from 'prop-types';

import YandexAnalytics from './components/Yandex';
import Pixel from './components/Pixel';
import Rambler from './components/Rambler';

import styles from './styles.module.scss';

const { publicRuntimeConfig } = getConfig();

const analyticsHash = {
	yandex: YandexAnalytics,
	pixel: Pixel,
	rambler: Rambler
};

const pageLoadTimeout = 2000;

const Analytics = ({ services }) => {
	const [isPageLoading, setPageLoading] = useState(true);

	useEffect(() => {
		const changePageLoading = () => setPageLoading(false);

		window.addEventListener('load', changePageLoading);
		const handle = setTimeout(changePageLoading, pageLoadTimeout);

		return () => {
			window.removeEventListener('load', changePageLoading);
			clearTimeout(handle);
		};
	}, []);

	return (
		<div className={styles.statistics}>
			{_(services).map((service) => {
				const AnalyticsComponent = analyticsHash[service];

				return (
					AnalyticsComponent && (
						<AnalyticsComponent
							key={service}
							className={styles.item}
							service={publicRuntimeConfig.services[service]}
							isPageLoading={isPageLoading}
						/>
					)
				);
			})}
		</div>
	);
};

Analytics.propTypes = {
	services: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Analytics;
